import React from "react";
import { IEmployeeId, IEmployees } from "../../Employee.props";
import ViewEmployee from "./ViewEmployee";

const ViewEmployeeIndex: React.FC<IEmployeeId> = ({employeeId ,setMethod}) => {
  return (
    <div>
      <ViewEmployee employeeId={employeeId} setMethod={setMethod}/>
    </div>
  )
}
export default ViewEmployeeIndex;